export default (props = {}) => <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.10791 3.69837L1.57349 7.23279L0.10791 5.76721L5.10791 0.767207L10.1079 5.76721L8.64233 7.23279L5.10791 3.69837Z" fill="#0057B8"/>
</svg>
 